'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Label } from '../Label/Label.js';

/**
 * FieldsetLegend component, used to display a legend for a fieldset.
 *
 * @example
 * <Fieldset.Legend>Skriv inn dine svar</Fieldset.Legend>
 */
const FieldsetLegend = forwardRef(function FieldsetLegend(rest, ref) {
    return (jsx(Label, { asChild: true, children: jsx("legend", { ref: ref, ...rest }) }));
});

export { FieldsetLegend };
